module.exports = __webpack_public_path__ + "img/list-dark-01.282f0095.png";